import type { FormError } from "@focus/formComponents";

/**
 * Converts a simple error object into the format expected by Focus Form components.
 * The input is a record where keys are field names and values are error messages.
 * The output is an object where each key is a field name and the value is an object with an 'errors' array.
 * @param errors 
 * @returns 
 */
export const toFocusFormErrors = (errors: Record<string, string>): FormError => ({
  errors: [],
  ...Object.fromEntries(
    Object.entries(errors).map(([field, message]) => [
      field,
      { errors: [message] },
    ]),
  ),
});


export const buildObjectSchemaFromArrayItems = (
  questionnaireSchema: any,
  rootSchema?: any,
) => {
  if (
    questionnaireSchema?.type !== "array" ||
    questionnaireSchema.items?.type !== "object"
  ) {
    return questionnaireSchema;
  }

  return {
    ...questionnaireSchema.items,
    type: "object",
    title: questionnaireSchema.title ?? questionnaireSchema.items.title,
    readOnly:
      questionnaireSchema.readOnly ?? questionnaireSchema.items.readOnly,
    definitions: questionnaireSchema.definitions ?? rootSchema?.definitions,
  };
};